function directive() {
    return {
        template: require('../../views/main/search_sidebar.html'),
        scope: true,
        replace: true,
        controllerAs: 'searchtable',
        link: function ($scope, element) {

        }
    }
}

directive.$inject = [];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/table/search_sidebar.js
 **/